import { Box, Divider, Typography } from "@mui/joy";
import React from "react";

const PageTitle = ({ title }) => {
    return (
        <Box sx={{ gap: 0.5, pb: 1, }} >
            <Typography level='h2'>{title}</Typography>
            <Divider component='div' sx={{ width: '25px', height: '2px', borderRadius: '20px' }} />
        </Box>
    )
}

export default PageTitle